import { render } from "./Topo.vue?vue&type=template&id=2415d2d6&scoped=true"
import script from "./Topo.vue?vue&type=script&lang=js"
export * from "./Topo.vue?vue&type=script&lang=js"

import "./Topo.vue?vue&type=style&index=0&id=2415d2d6&lang=css"
import "./Topo.vue?vue&type=style&index=1&id=2415d2d6&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\vue-argon-centrion\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2415d2d6"]])

export default __exports__